import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../buttons/icon-button/IconButton';
import { Icon } from '../../icons/Icon';
import styles from './ModalHeader.module.scss';

export const ModalHeader = ({
    onClose, children
}: Props) => {

    const { t } = useTranslation();

    return (
        <div className={styles.default}>
            {children && (
                <h3 className={styles.title}>
                    {children}
                </h3>
            )}

            <IconButton small
                title={t('modal.close')}
                className={styles.buttonRight}
                onClick={onClose}>
                <Icon size='small' type='general-ui-close' strokeWidth={2} />
            </IconButton>
        </div>
    );
};

type Props = PropsWithChildren<{
    onClose: MouseEventHandler;
}>;